import { CoveredMatrixExecutionMethod,CoveredMatrixGroup,CoveredMatrixItemInput,CreateCoveredMatrixOrderRequest } from "src/Interfaces/coveredMatrixOrder";
import { criterionOptionsForExecutionMethod,isFixedCallPriceCriterion,volumeOptions } from "./model";

export const validateCriteria=(items: CoveredMatrixItemInput[],executionMethod: CoveredMatrixExecutionMethod): string|null => {
  if(!items.length)
    return "حداقل یک آپشن انتخاب کنید.";
  const allowed=criterionOptionsForExecutionMethod(executionMethod).map((option) => Number(option.id));
  if(items.some((item) => !allowed.includes(item.criterionType)))
    return "نوع معیار با روش اجرا سازگار نیست.";
  if(items.some((item) => item.criterionValue!==null&&!Number.isFinite(item.criterionValue)))
    return "مقدار معیار معتبر نیست.";
  if(items.some((item) => isFixedCallPriceCriterion(item.criterionType)&&item.criterionValue!==null&&item.criterionValue<=0))
    return "حداقل قیمت کال باید بزرگ‌تر از صفر باشد.";
  return null;
};

export const validateDraft=(draft: CreateCoveredMatrixOrderRequest): string|null => {
  if(!draft.accountIds.length||draft.accountIds.some((id) => !Number.isInteger(id)||id<=0)||!draft.baseIsin||!Number.isFinite(draft.volumeInput)||draft.volumeInput<=0)
    return "اکانت، نماد پایه و حجم را کامل کنید.";
  if(![CoveredMatrixExecutionMethod.BothSides,CoveredMatrixExecutionMethod.BaseAlreadyOwned,CoveredMatrixExecutionMethod.FutureBasePurchase].includes(draft.executionMethod))
    return "روش اجرا را انتخاب کنید.";
  if(!volumeOptions.some((option) => Number(option.id)===draft.volumeCalculationType))
    return "روش تعیین حجم را انتخاب کنید.";
  if(![0,1,2].includes(draft.sendOrderType))
    return "ترتیب ارسال را انتخاب کنید.";
  if(draft.executionMethod===CoveredMatrixExecutionMethod.FutureBasePurchase&&(draft.manualBaseReferencePrice===null||!Number.isFinite(draft.manualBaseReferencePrice)||draft.manualBaseReferencePrice<=0))
    return "قیمت مبنای سمت اول باید بزرگ‌تر از صفر باشد.";
  return validateCriteria(draft.items,draft.executionMethod);
};

export const validateEditedGroup=(group: CoveredMatrixGroup): string|null => {
  const maxDoneVolume=[...group.items,...(group.removedItems||[])].reduce((max,item) => Math.max(max,item.doneVolume||0),0);
  if(!Number.isFinite(group.targetVolume)||group.targetVolume<=0||group.targetVolume<maxDoneVolume)
    return `کل حجم باید حداقل برابر حجم انجام‌شده (${maxDoneVolume.toLocaleString()}) باشد.`;
  return validateCriteria(group.items,group.executionMethod);
};

export const normalizeFormChange=(draft: CreateCoveredMatrixOrderRequest,name: string,value: unknown): CreateCoveredMatrixOrderRequest => {
  if(name==="baseIsin")
    return { ...draft,baseIsin: value==null? "":String(value),items: [] };
  if(name==="accountIds")
    return { ...draft,accountIds: Array.isArray(value)? value.map(Number):[] };
  if(name==="manualBaseReferencePrice")
    return { ...draft,manualBaseReferencePrice: value==null||value===""? null:Number(value) };
  return { ...draft,[name]: value==null||value===""? (name==="volumeInput"? 0:-1):Number(value) };
};
